<template>
  <div v-if="chosenChildOrg && childOrgsSelector">
    <div class="d-flex flex-row justify-space-between align-center mb-5">
      <h1 class="section-header__title mb-0">
        Сведения об аккредитациях организации
      </h1>
      <div class="structural-unit">
        <label>Выбор структурного подразделения</label>
        <v-autocomplete
          :value="chosenChildOrg.id"
          :items="childOrgsSelector"
          @change="selectOrganization($event)"
          dense
          clearable
          outlined
        ></v-autocomplete>
      </div>
      <div class="d-flex flex-row align-center">
        <v-btn
          class="white__v-btn orange-hover"
          :loading="getKcpUgsStatus"
          :disabled="blockBtn"
          @click="openDialog('add')"
        >
          Добавить аккредитацию
        </v-btn>
      </div>
    </div>
    <WrapperPreviewCategory>
      <GridTable
        :data-rows="serverData"
        :headers="headers.massive"
        :headers-for-rows="headersForRows"
        :loading-data="loadingTable"
        :num-cols="headers.countCells"
        :max-table-height="maxTableHeight"
        class="organizations-table"
        ref="npg-table"
        key="form-2-accreditation"
      >
        <template #actions="{row}">
          <v-btn @click="openDialog('edit', row)" :disabled="blockBtn" icon :loading="getKcpUgsStatus">
            <v-icon size="24" color="primary">mdi-file-edit-outline</v-icon>
          </v-btn>
          <v-btn @click="deleteRow(row)" icon :disabled="blockBtn" :loading="deleteLoading">
            <v-icon size="24" color="primary">mdi-delete-outline</v-icon>
          </v-btn>
        </template>
        <template #npg="{row}">
          <div style="">
            {{ row.kcpUgs.code }}
          </div>
          <div class="ml-3">
            {{ row.kcpUgs.name }}
          </div>
        </template>
        <template #isAccred="{value}">
          <i class="dot-accred" :has-accred="value"/>
        </template>
        <template #gaypa="{row}">
          {{ row.isAccred ? '' : row.gaypa }}
        </template>
        <template #gatxt="{value}">
          <comment-menu :text="value"/>
        </template>
      </GridTable>
      <div class='font-size-small mt-5' style="color: #89A0B0;">
        <img class="mr-3" src="@/assets/icons/forms2-4/Vector_lamp.svg" alt=""/>
        <span>Сведения о наличии аккредитаций внесены на основании данных конкурса прошлого года</span>
      </div>
    </WrapperPreviewCategory>
    <universal-dialog-v1
      ref="dialog"
      :data-for-dialog="dataForDialog"
      :headers-for-dialog="headersForDialog"
      @fetch-new-data="fetchDialogData($event)"
      :loading="savingData"
      :additional-data="additionalData"
      :spr-data="sprData"
      @closing-dialog="clearDataForDialog()"
    >
      <template #title>
        <h2>{{ mainHeaderTitle ? mainHeaderTitle : 'Добавить' }}</h2>
      </template>
      <template #actions="{close, sendData, loading, validSolo, isOneStage}">
        <div class="d-flex flex-row align-center justify-start" style="width: 100%">
          <v-btn
            class='white__v-btn'
            @click="close"
            width="120px"
          >
            Отменить
          </v-btn>
          <v-btn
            v-if="isOneStage"
            class='white__v-btn orange-hover  ml-2'
            @click="sendData"
            :loading="loading"
            :disabled="!validSolo || disabled"
            width="120px"
          >
            Сохранить
          </v-btn>
        </div>
      </template>
    </universal-dialog-v1>
    <v-dialog v-model="noAccreditationsError" width="1100">
      <v-card>
        <v-card-title style="word-break: break-word; text-align: justify; margin-bottom: 20px;">
          Уважаемые коллеги! Ваша заявка содержит предложения по&nbsp;установлению КЦП для обучения по&nbsp;не&nbsp;имеющим государственной аккредитации образовательным программам высшего образования (за&nbsp;исключением программ подготовки научных и&nbsp;научно-педагогических кадров в&nbsp;аспирантуре):
        </v-card-title>
        <v-card-text
            v-for="item in noAccreditationsCheckData" :key="item.id" style="color: #00599B; font-weight: 600">
          {{ item }}
        </v-card-text>
        <v-card-text style="word-break: break-word; text-align: justify; margin-top: 20px; font-weight: 500;">
          Для того, чтобы отправить это предложение Учредителю на&nbsp;согласование, необходимо в&nbsp;разделе &laquo;Сведения об&nbsp;аккредитациях организации&raquo; добавить соответствующую строку с&nbsp;указанием года первичного обязательства в&nbsp;получении аккредитации.
        </v-card-text>
        <v-card-actions style="justify-content: space-evenly">
          <v-btn class="blue__v-btn pl-3" @click="noAccreditationsError = false">Ок</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import GridTable from "@/components/GridTable/GridTable";
import WrapperPreviewCategory from "@/components/wrappers/WrapperPreviewCategory";
import {mapGetters} from "vuex";
import form4, {headerForDialog} from "@/pages/Organization/Forms2-4/configs/form4";
import UniversalDialogV1 from "@/components/Dialogs/universalDialog(v1.2)";
import {mapSpr} from "@/components/Dialogs/helpers";
import Form4AccreditationController from "@/controllers/Organizations/Forms(2-4)/Form4AccreditationController";
import CommentMenu from "@/components/Menus/comments-menu";
import {fiveFormsMixin} from "@/mixins/formUsl";
import {setFileFunctions} from "@/mixins/fileFucntions";
import {headerTooltipFunctions} from "@/mixins/forms5/headerTooltip";
import Form2OffersController from "@/controllers/Organizations/Forms(2-4)/Form2OffersController";

export default {
  name: "form4Accreditation",
  mixins: [fiveFormsMixin, headerTooltipFunctions, setFileFunctions],
  components: {
    CommentMenu,
    UniversalDialogV1,
    WrapperPreviewCategory, GridTable,
  },
  data() {
    return {
      serverData: [],
      noAccreditationsError: false,
      noAccreditationsCheckData: [],
      loadingData: false,
      changingHeaders: false,
      headers: form4,
      editApi: '/api/form4/set',
      savingData: false,
      deleteLoading: false,
      dataForDialog: null,
      additionalData: null,
      mainHeaderTitle: '',
      headersForDialog: headerForDialog,
      childOrgs: [],
      childOrgsSelector: [],
      chosenChildOrg: null,
    }
  },

  computed: {
    ...mapGetters('spr', {getAvailableOrgs: 'getAvailableOrgs'}),
    ...mapGetters('spr', {getKcpUgs: 'getKcpUgs', getKcpUgsStatus: 'getKcpUgsStatus'}),
    ...mapGetters('checkFilled', {currentStage: 'currentStage'}),

    headersForRows() {
      return this.headers.massive.filter(el => el.variable)
    },
    maxTableHeight() {
      return window.screen.availHeight - 350 + 'px'
    },
    loadingTable() {
      return this.get_spr_data_usl_loading || this.loadingData
    },
    sprData() {
      const getKcpUgsNoAsp = this.getKcpUgs.filter(el => el.uslId !== 6);
      return {
        sprGaypa: [{value: 2010, text: '2010 год', filter: null},
          {value: 2011, text: '2011 год', filter: null},
          {value: 2012, text: '2012 год', filter: null},
          {value: 2013, text: '2013 год', filter: null},
          {value: 2014, text: '2014 год', filter: null},
          {value: 2015, text: '2015 год', filter: null},
          {value: 2016, text: '2016 год', filter: null},
          {value: 2017, text: '2017 год', filter: null},
          {value: 2018, text: '2018 год', filter: null},
          {value: 2019, text: '2019 год', filter: null},
          {value: 2020, text: '2020 год', filter: null},
          {value: 2021, text: '2021 год', filter: null},
          {value: 2022, text: '2022 год', filter: null},
          {value: 2023, text: '2023 год', filter: null},
          {value: 2024, text: '2024 год', filter: null},],
        sprKcpUgs: mapSpr(getKcpUgsNoAsp, 'id', (el) => `${el.code} ${el.name} ${this.checkKcpUgs(el) ? '(все входящие НПС)' : ''}`),
      }
    },
    blockBtn() {
      if (this.getAuthData?.realm_access?.roles?.includes('ADMIN_ROLE')) {
        return false
      } else return !!(this.currentStage === 5 || this.organizationBlocked);
    }
  },

  watch: {
    getAvailableOrgs() {
      this.loadingDataTable();
    },
  },

  created() {
    this.loadingDataTable();
  },

  methods: {
    checkKcpUgs(kcpUgs) {
      if ([30, 31, 32, 33, 34, 50, 51, 52, 53, 54, 55].includes(kcpUgs.ugsId) && kcpUgs.ugs &&
        [1, 2, 3].includes(kcpUgs.uslId)) return true;
      if ([30, 31, 32, 33, 34].includes(kcpUgs.ugsId) && kcpUgs.ugs && kcpUgs.uslId === 9) return true;
      return !!([7, 50, 51, 52, 53, 54, 55].includes(kcpUgs.ugsId) && kcpUgs.ugs && kcpUgs.uslId === 12);

    },
    async loadingDataTable() {
      this.loadingData = true;
      try {
        if (this.chosenChildOrg === null || this.chosenChildOrg === undefined) { //первая загрузка
          this.childOrgs = this.getAvailableOrgs;
          this.childOrgsSelector = this.getAvailableOrgs.map((el) => {
            return {
              text: el.name,
              value: el.id,
            }
          });
          this.chosenChildOrg = this.childOrgs[0];
        }
        // console.log(this.chosenChildOrg, this.childOrgsSelector);

        this.serverData = await Form4AccreditationController.getData(this.chosenChildOrg.id);
        this.serverData.forEach((el) => {
          if (el.gadtb && el.gadte === null) {
            el.isEndless = true
          }
        })

        this.noAccreditationsCheckData = await Form2OffersController.noAccreditationsCheck(this.chosenChildOrg.id);
        if (this.noAccreditationsCheckData.length > 0) {
          this.noAccreditationsError = true;
        }

        this.loadingData = false;
      } catch (e) {
        this.loadingData = false;
      }
    },

    clearDataForDialog() {
      this.mainHeaderTitle = '';
      this.dataForDialog = null;
      this.additionalData = null;
    },

    async deleteRow(row) {
      try {
        const accept = confirm('Вы уверены что хотите удалить эту строку?')
        if (!accept) {
          return;
        }
        this.deleteLoading = true;
        const res = await Form4AccreditationController.deleteRow(row.id)
        if (res) {
          const ind = this.serverData.findIndex(el => el.id === row.id);
          if (ind !== -1) {
            this.serverData.splice(ind, 1);
          }
        }
        this.deleteLoading = false;
      } catch (e) {
        console.error('/api/form4/delete', e)
        this.deleteLoading = false;
      }
    },
    /**
     * @param {'add' | 'edit'} typeAction
     * @param {Object} [row]
     * */
    async openDialog(typeAction = 'add', row) {
      if (row) {
        if (row.kcpUgs)
          this.mainHeaderTitle = row.kcpUgs?.code + ' ' + row.kcpUgs?.name;
      }
      if (typeAction === 'edit') {
        this.additionalData = {
          id: row?.id ?? null,
          "kcpUgs": row.kcpUgs?.id ? {
            "id": row.kcpUgs?.id,
          } : null,
        };
        this.dataForDialog = {
          idSprKcpUgs: row.kcpUgs?.id,
          gasnm: row.gasnm,
          isAccred: row.isAccred,
          isEndless: row.isEndless,
          gadtb: row.gadtb,
          gaypa: row.gaypa,
          gadte: row.gadte,  //date   this.parseDate(
          gatxt: row.gatxt,
        };
      }
      await this.$refs.dialog.openDialog()
    },

    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },

    parseDate(date) {
      if (!date) return null
      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    async fetchDialogData(obj) {
      this.savingData = true;
      if (obj.isEndless === true) {
        obj.gadte = null
      }
      if (obj.isAccred) {
        obj.gaypa = ''
      }
      try {
        const mail = {
          ...obj,
          kcpUgs: {
            id: obj.idSprKcpUgs,
          },
        }
        const res = await Form4AccreditationController.setData(mail, this.chosenChildOrg.id)
        if (res) {
          this.savingData = false;
          if (obj.id) {
            const index = this.serverData.findIndex(el => el.id === obj.id);
            this.serverData.splice(index, 1, res) //res.data
          } else {
            this.serverData.push(res)
          }
          this.dataForDialog = null;
          await this.$refs.dialog.closeDialog();
        }
        this.savingData = false;
      } catch (e) {
        console.log("e", e)
        this.savingData = false;
      }
    },

    selectOrganization(org) {
      this.chosenChildOrg = this.childOrgs.find(el => el.id === org);
      this.loadingDataTable();
    },
  },
}
</script>

<style scoped>

</style>